(() => {
  const initStickyAtc = (sectionId) => {
    const bar = document.getElementById(`StickyAtc-${sectionId}`);
    const stickyBtn = document.getElementById(`StickyAtcButton-${sectionId}`);
    const mainBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);

    if (!bar || !stickyBtn || !mainBtn) return;

    stickyBtn.addEventListener('click', () => {
      const target = document.querySelector('.kaching-bundles');
      if (!target) return;
      const header = document.querySelector('.header-wrapper, #shopify-section-header, header');
      const offset = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });

    let mainBtnVisible = true;
    let footerVisible = false;

    const show = () => {
      if (footerVisible) return;
      bar.classList.add('sticky-atc--visible');
      bar.setAttribute('aria-hidden', 'false');
    };
    const hide = () => {
      bar.classList.remove('sticky-atc--visible');
      bar.setAttribute('aria-hidden', 'true');
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        mainBtnVisible = entry.isIntersecting;
        mainBtnVisible ? hide() : show();
      },
      { threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );
    observer.observe(mainBtn);

    const footer = document.querySelector('.footer');
    if (footer) {
      new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          footerVisible ? hide() : (!mainBtnVisible && show());
        },
        { threshold: 0 }
      ).observe(footer);
    }

    // Sync disabled state and text when variant changes
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data.sectionId !== sectionId) return;

      const sourceBtn = data.html?.getElementById(`ProductSubmitButton-${sectionId}`);
      if (!sourceBtn) return;

      if (sourceBtn.hasAttribute('disabled')) {
        stickyBtn.setAttribute('disabled', 'disabled');
      } else {
        stickyBtn.removeAttribute('disabled');
      }

      const sourceText = sourceBtn.querySelector('span')?.textContent?.trim();
      if (sourceText) stickyBtn.textContent = sourceText;
    });

    // Mirror aria-disabled set by product-form.js during add-to-cart loading
    const mainForm = document.getElementById(bar.dataset.productForm);
    if (mainForm) {
      new MutationObserver(() => {
        const isLoading = mainBtn.classList.contains('loading');
        stickyBtn.classList.toggle('loading', isLoading);
        if (mainBtn.getAttribute('aria-disabled') === 'true') {
          stickyBtn.setAttribute('aria-disabled', 'true');
        } else {
          stickyBtn.removeAttribute('aria-disabled');
        }
      }).observe(mainBtn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    }
  };

  document.querySelectorAll('[id^="StickyAtc-"]').forEach((el) => {
    initStickyAtc(el.dataset.section);
  });
})();
